import styled from 'styled-components';
import { ReactComponent as _CopyLink } from 'Images/copy_link.svg';

export const CopyLinkWrapper = styled.div`
  position: relative;
  cursor: pointer;
  width: 34px;
  height: 34px;
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgba(28, 34, 67, 0.03);
  border: solid 1px ${({ theme }) => theme.buttons.custom.border};
  background-color: ${({ theme }) => theme.buttons.custom.background};
  margin-right: 8px;
  &:hover {
    background-color: #f1f4f7 ;
  }
  &:active{
    background-color: #63758d ;
    & > svg {
      & > path {
        fill: #fff;
      }
    }
  }
  
`;
CopyLinkWrapper.displayName = 'CopyLink';

export const CopyLinkIcon = styled(_CopyLink)`
  position: absolute;
  cursor: pointer;
  left: 8px;
  top: 8px;
`;
CopyLinkIcon.displayName = 'CopyLinkIcon';
